import { invoke } from '@tauri-apps/api/core';

import type { CoreClient, FoundationStatus } from '../contracts/foundation';

export class TauriCoreClient implements CoreClient {
  async initialize(): Promise<FoundationStatus> {
    return invoke<FoundationStatus>('initialize_core');
  }
}
